module.exports = require("country-flag-icons/unicode");